/**
 * Charter departure airports are no longer persisted to localStorage (they now
 * rely on HTTP cache-control on the charter/departure-airports endpoint). This
 * plugin clears the previously persisted entries so returning clients don't keep
 * hitting the "Exceeded storage quota" error.
 *
 * TODO: Remove this plugin after 2026-10-09, once existing clients have had time
 * to load the site and clear the stale airports from their localStorage.
 */
const PERSISTED_AIRPORT_KEYS = [
  'charterPackagesState_airports',
  'rootState_airports',
  'rootState_airports_exp',
]

export default defineNuxtPlugin(() => {
  PERSISTED_AIRPORT_KEYS.forEach(key => tryRemoveLocalStorage(key))
})
